import React, { FC } from 'react';
import styled from 'styled-components';
import { FETCH_ASSETS_URL } from 'appenv';
import { COLORS } from 'components/twilio/constants';
import { useTranslation } from 'react-i18next';
import TRANSLATION from 'components/twilio/translations';

const ChatListPlaceholder = `${FETCH_ASSETS_URL}/assets/chatListPlaceholder.svg`;

const ConversationListPlaceholderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ChatImage = styled.img`
  max-height: 100px;
  max-width: 100px;
`;

const StyledText = styled.h4`
  color: ${COLORS.TEXT_DARK};
`;

const ConversationListPlaceholder: FC = () => {
  const { t } = useTranslation();

  return (
    <ConversationListPlaceholderContainer>
      <ChatImage src={ChatListPlaceholder} alt="Chat Empty State Icon" />
      <StyledText>{t(...TRANSLATION.COMMON.NO_MESSAGES)}</StyledText>
    </ConversationListPlaceholderContainer>
  );
};

export default ConversationListPlaceholder;
